import { KeyValuePair } from './KeyValuePair';
import { SensorSet } from './SensorSet';
import { BaseSensor } from './BaseSensor';
import { TimeFrame } from './TimeFrame';
import { TimeFrameManager } from './TimeFrameManager';
import { ZoneData } from './ZoneData';
import { DataIoService } from '../services/data-io.service';
import { TranslationService } from '../services/translation.service';
import { Helper } from './Helper';
import { MenuLogic } from './MenuLogic';
import { Programs } from './Programs';
import { Generator }  from './Generator';
export class MenuNode  {

	private static _debug=false;

	static enableDebugging(){
		MenuNode._debug = true;
	}
	static disableDebugging(){
		MenuNode._debug = false;
	}
	static isDebugging(){
		return MenuNode._debug;
	}
	helper = new Helper();
	evaluateGetter(text:string,options?:string){
		return this.helper.evaluateGetter(text,this,options);
	}

	// internal use
	private parent: MenuNode;
	private childs: Array<MenuNode>;
	private name: string;
	private internal_id: number;
	private level: number;
	private static root:MenuNode;
	private static increment_id: number = 0;
	private current: boolean;
	private identifier: any;
	private program : string;
	timeout: number;
	timeout_action: string;
	timeout_action_target: string;
	timeout_action_target_index: number;
	backTarget:string;	
	conditionalTargets:any=undefined;
	// view-data
	infoId:string;
	infoText:string='';
	title: string; // 
	text: Array<string>;
	subTitle: string;
	icon: string;
	help: string;
	enabled: string;
	/*
	_selected:string;
	set selected(sel:string){
		console.log("Setting selected on "+this.identifier+ " to "+sel);
		this._selected = sel;
	}
	get selected():string{
		return this._selected;
	}*/
	selected:string;
	opened:boolean=false;
	menuType: string;
	template: string;
	template_parameter: string;
	buttons: string;
	mutedButtons:string;
	blinkingButtons:string;
	target: string;
	dictionary: Array<KeyValuePair>;
	unit:string;
	position = MenuNode;
	value: any;
	defaultValue: any;
	hasProgram():boolean{
		if(this.program){
			return Programs[this.program] != undefined;
		}
		return false;
	}
	getProgram():CallableFunction{
		return Programs[this.program];
	}
	static setRoot(r:MenuNode){
		MenuNode.root=r;
	}
	static getRoot():MenuNode{
		return MenuNode.root;
	}
	static translator: TranslationService;
	static setTranslator(t: TranslationService){
		MenuNode.translator=t;
	}
	static getTranslator():TranslationService{
		return MenuNode.translator;
	}
	static ioService: DataIoService;
	static getDataIoService():DataIoService{
		return MenuNode.ioService;
	}
	static setDataIoService(_ioService: DataIoService) {
		MenuNode.ioService = _ioService;
	}

	hasConditionalTargets():boolean{
		return this.conditionalTargets != undefined;
	}
	getConditionalTargetNode():MenuNode{
		return this.getTargetNode(this.getConditionalTarget());
	}
	getConditionalTarget():string{
		if(!this.hasConditionalTargets()){
			return undefined;
		}
		let condition = this.evaluateGetter(this.conditionalTargets['condition']);
		console.log("conditional target for condition "+this.conditionalTargets['condition']+ " evaluates to: "+condition);
		if(condition in this.conditionalTargets){
			console.log("returning conditional target "+this.conditionalTargets[condition]);
			return this.conditionalTargets[condition];
		}
		if('default' in this.conditionalTargets){
			return this.conditionalTargets['default'];
		}
	
		console.log("conditional target not found for "+condition);
		return undefined;
	}

	addButton(btn:string):void{
		let btns = this.buttons.split(',');
		if(!btns.includes(btn)){
			btns.push(btn);
		}
		this.buttons = btns.join(',');
	}
	removeButton(btn:string):void{
		let btns = this.buttons.split(',');
		let idx = btns.indexOf(btn);
		if(idx >= 0){
			btns.splice(idx,1);
		}
		this.buttons = btns.join(',');
	}
	hasButton(btn:string):boolean{
		if(!this.buttons){
			return false;
		}
		let btns = this.buttons.split(',');
		return btns.includes(btn);
	}
	open(){
		this.opened = true;
	}
	close(){
		this.opened = false;
	}
	isOpen(){
		return this.opened;
	}
	getButtons() {
		if (this.buttons) {
			return Helper.split(this.buttons,',').map(item => item.trim());
		} else {
			return new Array<string>();
		}
	}

	getBlinkingButtons() {
		if (this.blinkingButtons) {
			return Helper.split(this.blinkingButtons,',').map(item => item.trim());
		} else {
			return new Array<string>();
		}
	}
	getMutedButtons() {
		if (this.mutedButtons) {
			return Helper.split(this.mutedButtons,',').map(item => item.trim());
		} else {
			return new Array<string>();
		}
	}
	
	setTemplate(str:string):void{
		this.template = str;
	}

	getTemplate() : string{
		return this.template;
	}

	setTemplateParameters(params:string){
		this.template_parameter = params;
	}
	
	getTemplateParameters(): Array<string> {
		if (this.template_parameter) {
			return Helper.split(this.template_parameter,',').map(item => item.trim());
		} else {
			return new Array<string>();
		}
	}
	getScreenTemplate() {
		return this.template;
	}

	setIdentifier(_id:string):void{
		this.identifier =_id;
	}

	setButtons(str:string){
		this.buttons = str;
	}
	setType(_type: string): void {
		this.menuType = _type;
	}
	getType(): string {
		return this.menuType;
	}

	setTitle(_title: string): void {
		this.title = _title;
	}
	getTitle(): string {
		return this.parseText(this.title);
	}
	getInfoText():string{
		if(this.hasInfoText()){
			return this.parseText(this.infoText);
		}		
		return "";
	}

	hasInfoText():boolean{
		return this.infoText != '';
	}


	setSubTitle(_title: string): void {
		this.subTitle = _title;
	}
	getSubTitle(): string {
		return this.parseText(this.subTitle);
	}
	getHelp():string{
		return this.help;
	}
	setHelp(str:string):void{
		this.help = str;
	}
	hasHelp() : boolean{
		return this.help != "";
	}
	setIcon(_icon: string): void {
		this.icon = _icon;
	}
	getIcon(): string {
		if (!this.icon) {
			return "";
		}
		return this.icon;
	}

	createBatched(nodeData) {
		let elements = new Array<MenuNode>();
		if (!nodeData['batch']) {
			return elements;
		}
		let range = Helper.split(nodeData['batch'],':');
		if (range.length < 3) {
			this.debug("Error: invalid batch-range: " + nodeData['batch']);
			return elements;
		}
		let begin = parseInt(this.evaluateGetter(range[0]));
		let step = parseInt(this.evaluateGetter(range[1]));
		let end = parseInt(this.evaluateGetter(range[2]));
		let varName = 'idx';

		if (range.length == 4) {
			varName = range[3];
		}

		nodeData['batch'] = '';

		for (let idx = begin; idx <= end; idx += step) {
			this.debug("Adding element " + idx);
			let element = new MenuNode(nodeData);
			element.applyBatchReplacements(varName, idx);

			elements.push(element);
		}

		this.debug("Creating " + (((end - begin) / step) + 1) + " elements");

		return elements;
	}

	applyBatchReplacements(name: string, idx) {
		let re = new RegExp('{{'+name+'}}','g');
		//let re = '{{'+name+'}}';
		this.debug("Applying batch replacements.");
		if ( typeof(this.name) == "string" ){
			this.name = this.name.replace(re, idx + "");
		}

		if ( typeof(this.onConfirmAction) == "string" ) {
			this.onConfirmAction = this.onConfirmAction.replace(re, idx + "");
		}

		if ( typeof(this.title) == "string" ){
			this.title = this.title.replace(re, idx + "");
		}
		if ( this.text ) {
			for(let idx in this.text){
				if( typeof(this.text[idx]) == "string"){
					this.text[idx] = this.text[idx].replace(re, idx + "");
				}
			}
		}
		if ( typeof(this.subTitle) == "string" ) {
			this.subTitle = this.subTitle.replace(re, idx + "");
		}

		if ( typeof(this.identifier) == "string" ) {
			this.identifier = this.identifier.replace(re, idx + "");
		}

		if ( typeof(this.value) == "string" ) {
			this.value = this.value.replace(re, idx + "");
		}

		if ( typeof(this.target) == "string" ) {
			this.target = this.target.replace(re, idx + "");
		}

		if ( typeof(this.defaultValue) == "string" ) {
			this.defaultValue = this.defaultValue.replace(re, idx + "");
		}
		if ( typeof(this.enabled) == "string" ) {
			this.enabled = this.enabled.replace(re, idx + "");
		}

		if ( typeof(this.selected) == "string" ) {
			this.selected = this.selected.replace(re, idx + "");
		}
		for (let child of this.childs) {
			this.debug("Applying child replacements.");
			child.applyBatchReplacements(name, idx);
		}
		this.debug("done.");
	}


	makeId(length) {
	   var result           = '';
	   var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
	   var charactersLength = characters.length;
	   for ( var i = 0; i < length; i++ ) {
	      result += characters.charAt(Math.floor(Math.random() * charactersLength));
	   }
	   return result;
	}
	constructor(data?: any, parent?: MenuNode, idx?: any) {
		this.name ='';
		this.internal_id = MenuNode.increment_id;
		this.childs = new Array<MenuNode>();
		this.text = new Array<string>();
		this.dictionary = new Array<KeyValuePair>();
		this.title="";
		this.value="";
		this.defaultValue="";
		this.subTitle="";
		this.data = new Map<string,string>();

		MenuNode.increment_id++;


		if (!data) {
			this.debug("no data provided. not constructing.");
			return;
		}
		if (data['id']) {
			this.identifier = data['id'];
		}else{
			this.identifier = this.makeId(8);
		}
		if(data['unit']){
			this.unit = data['unit'];
		}else{
			this.unit = '';
		}
		this.current = false;
		if (data['name']) {
			this.name = data['name'];
		} else {
			this.name = "";
		}
		if(data['back']){
			this.backTarget=data['back'];
		}
		if(data['selected']){
			this.selected = data['selected'];
		}
		if(data['program']){
			let program = data['program'];;
			this.program = program;
		}
		if(data['help']){
			this.help = data['help'];
		}else{
			this.help = "";
		}
		if (data['title']) {
			this.title = data['title'];
		} else {
			this.title = "";
		}

		if (data['subtitle']) {
			this.subTitle = data['subtitle'];
		} else {
			this.subTitle = "";
		}

		if (data['icon']) {
			this.icon = data['icon'];
		} else {
			this.icon = "";
		}

		if (data['type']) {
			this.menuType = data['type'];
		} else {
			this.menuType = "";
		}

		if (data['template']) {
			this.template = data['template'];
		} else {
			this.template = "";
		}

		if(data['infoId']){
			this.infoId = data['infoId'];
		}else{
			this.infoId = "";
		}

		if(data['infoText']){
			this.infoText = data['infoText'];
		}else{
			this.infoText = '';
		}
		
		if (data['template_parameter']) {
			this.template_parameter = data['template_parameter'];
		} else {
			this.template_parameter = "";
		}

		if (data['timeout']) {
			this.setTimeout(data['timeout']);
		}


		if (data['text']) {
			this.text = data['text'];
		} else {
			this.text = new Array<string>();
		}

		if (data['timeout_action']) {
			this.setTimeoutAction(data['timeout_action']);
		}
		if(data['mutedButtons']){
			this.mutedButtons = data['mutedButtons'];
		}else{
			this.mutedButtons = "";
		}


		if (data['buttons']) {
			this.buttons = data['buttons'];
		} else {
			this.buttons = "";
		}


		if (data['blinkingButtons']) {
			this.blinkingButtons = data['blinkingButtons'];
		} else {
			this.blinkingButtons = "";
		}
		if (data['target']) {
			this.target = data['target'];
		} else {
			this.target = "";
		}

		if(data['conditionalTargets']){
			this.conditionalTargets = data['conditionalTargets'];
		}
		if (data['value']) {
			this.value = data['value'];
		} else {
			this.value = "";
		}

		if (data['defaultValue'] != null && data['defaultValue'] != undefined) {
			this.defaultValue = data['defaultValue'];
			if (this.value == null || this.value == undefined) {
				this.value = data['defaultValue'];
			}
		} else {
			this.defaultValue = "";
		}

		if (data['onConfirm']) {
			this.onConfirmAction = data['onConfirm'];
		}

		if(data['data']){
			for(let key in data['data']){
				this.data.set(key,data['data'][key]);
			}
		}
		if (data['listDictionary']) {
			for (let element of data['listDictionary']) {
				this.dictionary.push(new KeyValuePair(element['key'], element['value']));
			}
		} else {
			this.dictionary = new Array<KeyValuePair>();
		}
		if (data['children']) {
			if(Array.isArray(data['children'])){
				for (let childData of data['children']) {
					if (childData['batch']) {
						let childs = this.createBatched(childData);
						for (let batchChild of childs) {
							this.addChild(batchChild);
						}
					} else {
						let child = new MenuNode(childData);
						this.addChild(child);
					}
				}
			}
			if(typeof(data['children']) == "string" && data['children'].startsWith('generator:')){
				let generatorFn = data['children'].split(':')[1];
				let childs = Generator[generatorFn]();
				for(let child of childs){
					this.addChild(child);
				}
			}
		}
		if (parent) {
			this.setParent(parent);
		} else {
			this.setLevel(0);
		}

		if (data['enabled']) {
			this.enabled = data['enabled'];
		}
	}

	hasBackTarget() {
		return (this.backTarget != undefined && this.backTarget != null && this.backTarget != "");
	}
	setBackTarget(target:string){
		this.backTarget = this.target;
	}
	getBackTarget(){
		return this.backTarget;
	}

	hasTarget() {
		return (this.target != undefined && this.target != null && this.target != "");
	}


	setTarget(target: string): void {
		this.target = target;
	}

	getTarget(): string {
		return this.target;
	}

	getDictionary() {
		return this.dictionary;
	}
	getTexts(){
		return this.text;
	}


	getLevel() {
		return this.level;
	}
	setLevel(level) {
		this.level = level;
		for (let child of this.childs) {
			child.setLevel(level + 1);
		}
	}











	/**
		Node/Tree-Structure.
	**/


	hasNextSibling() {
		if (!this.hasParent()) {
			return false;
		}
		let idx = this.getParent().getIndexForChild(this);

		if (idx != -1 && idx < this.getParent().getChilds().length - 1){
			return this.getParent().getChildByIndex(idx).isEnabled();
		}
		return false;
	}
	getNextSibling() {
		if (this.hasNextSibling()) {
			let idx = this.getParent().getIndexForChild(this);
			let sibling = this.getParent().getChildByIndex(idx + 1);
			this.debug("Returning sibling " + sibling.getName());
			return sibling;
		} else {
			this.debug("Cannot get sibling: " + this.getName() + " has no sibling.");
		}
		return null;
	}
	hasPreviousSibling() {
		if (!this.hasParent()) {
			return false;
		}
		let idx = this.getParent().getIndexForChild(this);
		if(idx > 0){
			return this.getParent().getChildByIndex(idx-1).isEnabled();
		}
		
	}
	getUnit(){
		if(this.unit){
			return this.unit;
		}
		return '';
	}

	getPreviousSibling() {
		if (this.hasPreviousSibling()) {
			let idx = this.getParent().getIndexForChild(this);
			return this.getParent().getChildByIndex(idx - 1);
		}
		return null;
	}


	filters=new Map<string,CallableFunction>();


	setFilter(name:string,filterFn){
		//this.debug("adding filter for childs of " +this.getName());
		this.filters.set(name, filterFn);
	}


	removeFilter(name:string){
		//this.debug("removing filter for childs of " +this.getName());
		this.filters.delete(name);

	}
	hasParameter(param:string):boolean{
		return (this.getTemplateParameters().indexOf(param) != -1);
	}

	getChilds():Array<MenuNode>{
		if(this.filters.size == 0){
			return this.childs;
		}else{
		
			return this.applyFilters(this.childs);
		}
	}

	applyFilters(nodes: Array<MenuNode>):Array<MenuNode>{

		let filtered = nodes;
		this.filters.forEach((filterFn: CallableFunction, key: string) => {
			filtered = filterFn(filtered);		
		});
		return filtered;
	}
	hasParent() {
		return (this.parent != null && this.parent != undefined);
	}


	setParent(parent: MenuNode): void {
		if (this.hasParent()) {
			this.parent.removeChild(this);
		}
		this.setLevel(parent.getLevel() + 1);
		this.parent = parent;
	}
	getParent() {
		return this.parent;
	}
	removeParent(): void {
		this.parent = null;
		this.level = 0;
	}
	public printAncestorTree(){
			let ancestors = this.getAncestors();
			ancestors = ancestors.reverse();
			let level = " ";
			for(let anc of ancestors){
				console.log(level +"["+anc.getIdentifier()+"|"+anc.getTitle()+"]");
				level+=" ";
			}
			console.log(level +"["+this.getIdentifier()+"|"+this.getTitle()+"]");

	}
	public getAncestors(): Array<MenuNode>{
		let ancestors = new Array<MenuNode>();
		let ancestor = this.getParent();
		if(!ancestor){
			return ancestors;
		}
		ancestors.push(ancestor);
		while(ancestor.hasParent()){
			ancestor = ancestor.getParent();
			ancestors.push(ancestor);
		}
		return ancestors;
	}

	public isDescendantOf(id : string):boolean{
		let ancestor = this.getParent();
		if(ancestor==null || ancestor == undefined){
			return false;
		}
		while(ancestor.hasParent()){

			if(ancestor.getIdentifier() == id){
				return true;
			}
			ancestor = ancestor.getParent();
		}
		return false;
	}
	addChild(child: MenuNode): boolean {
		if (!this.hasChild(child)) {
			child.setParent(this);
			child.setLevel(this.level + 1);
			this.childs.push(child);
			return true;
		} else {
			return false;
		}
	}
	removeChild(child: MenuNode): boolean {
		let idx = this.childs.indexOf(child);
		if (idx != -1) {
			child.removeParent();
			this.childs.splice(idx, 1);
			return true;
		}
		return false;

	}
	hasChild(child?: MenuNode): boolean {
		if (child === null || child === undefined) {
			return this.getChilds().length > 0;
		}
		return (this.getChilds().indexOf(child) != -1);
	}
	getChild(id: number): MenuNode {
		for (let child of this.getChilds()) {
			if (child.internal_id === id) {
				return child;
			}
		}
		return null;
	}
	getIndexForChild(child: MenuNode) {
		return this.getChilds().indexOf(child);
	}
	getChildByIndex(idx: number): MenuNode {
		if (this.getChilds().length >= idx) {
			return this.getChilds()[idx];
		}
		this.debug("no child with index " + idx + " on " + this.name);
		return null;
	}
	getIndexOnParent(){
		if(this.hasParent()){
			return this.getParent().getIndexForChild(this);
		}else{
			return -1;
		}
	}




	setName(name: string): void {
		this.name = name;
	}
	getName(): string {
		return this.parseText(this.name);
	}
	setValue(arg: any): void {
		this.value = arg;
	}
	getValue() {
		return this.parseText(this.value);
	}

	/***
	Helpersinfo
	**/
	setTimeout(data): boolean {
		let timeout = this.parseTimeout(data);
		if (timeout == -1) {
			this.debug("invalid timeout: " + data);
			this.timeout = -1;
			return false;
		} else {
			this.timeout = timeout;
			return true;
		}
	}
	parseTimeout(data): number {
		if (!data || data == undefined) {
			return -1;
		}
		if (typeof data == "string") {
			let intVal = parseInt(data);
			if (data == ("" + intVal)) {
				return intVal;
			} else {
				if (data.length == ("" + intVal).length + 1) {
					switch (data[data.length - 1]) {
						case 's': {
							return intVal;
						}
						case 'm': {
							return intVal * 60;
						}
						case 'h': {
							return intVal * 3600;
						}
						default: {
							this.debug("error parsing " + data);
							return -1;
						}
					}
				}
			}
		}
		if (typeof data == "number") {
			return data;
		}
		this.debug("error parsing data: " + data + "(not string and not number)");
		return -1;
	}


	setTimeoutAction(_data: any): void {
		let data = Helper.split(_data,':');

		if (data.length == 2) {
			this.timeout_action = data[0];
			this.timeout_action_target = data[1];
			if (data[0] == 'goto' && data[1] == 'child') {
				this.timeout_action_target_index = 0;
			}
			return;
		}

		if (data.length == 3) {
			this.timeout_action = data[0];
			this.timeout_action_target = data[1];
			this.timeout_action_target_index = parseInt(data[2]);
			return;
		}

		this.debug("timeout_action malformed: " + data + "( should be formed \"action:target:target_index\"");
	}
	getTimeoutTarget() {
		let pattern = this.timeout_action;
		if (this.timeout_action_target) {
			pattern += ":" + this.timeout_action_target;
			if (this.timeout_action_target_index) {
				pattern += ":" + this.timeout_action_target_index;
			}
		}
		
		return this.getTargetNode(pattern);

	}
	getBackTargetNode(){
		return this.getTargetNode(this.backTarget);
	}
	splash:boolean=false;
	isSplash(){
		return this.splash;
	}
	setSplash(b:boolean):void{
		this.splash = b;
	}
	getTargetNode(target_string?: string): MenuNode {

		let targetPattern = this.target;

		if (target_string) {
			targetPattern = target_string;
		}
		this.debug("Getting target node for " + targetPattern);
		let parts = Helper.split(targetPattern,':');
		let ref = this;
		
		//goto:child:0"	
		if (parts[0].length > 0) {
			switch (parts[0]) {
				case 'goto': {
					if (parts.length > 1) {
						switch (parts[1]) {
							case 'child': {
								let idx = 0;
								if (parts.length > 2) {
									idx = parseInt(parts[2]);
								}
								ref.debug("Returning child: " +parts[2] + " of "+ref.getChilds().length);
								return ref.getChildByIndex(idx);
							}
							case 'previous':{
								if(ref.hasParent()){
									let idx = ref.parent.getIndexForChild(ref);
									if(idx < 1){
										return;
									}
									idx--;
									while(!ref.parent.getChildByIndex(idx).isEnabled() && idx >0){
										idx--;
									}
									if(ref.parent.getChildByIndex(idx).isEnabled()){
										return ref.parent.getChildByIndex(idx)
									}else{
										return null;
									}
									return 
								}else{
									console.log("Cannot resolve element: "+parts.join('/'));
								}
							}
							case 'next': {
								if(ref.hasParent()){
									let idx = ref.parent.getIndexForChild(ref);
									idx++;
									while(!ref.parent.getChildByIndex(idx).isEnabled() && idx < ref.parent.getChilds().length){
										//console.log("skipping "+ref.parent.getChildByIndex(idx).getIdentifier());
										idx++;
									}
									return ref.parent.getChildByIndex(idx);
								}else{
									console.log("Cannot resolve element: "+parts.join('/'));
								}
							}
							case 'previous': {
								let idx = ref.parent.getIndexForChild(ref);
								return ref.parent.getChildByIndex(idx - 1);
							}
							case 'historyBack':{
								console.log("History back found.");
								let order = 'firstInHistory';
								//order = 'closestSibling';

								if(parts.length >= 2){
									// return first element in History that is a sibling with an index lower than current element.
									if(parts[2]=="previous" && this.hasParent()){
										if(order == 'firstInHistory'){

											let myIdx = this.getIndexOnParent();
											for(let i=MenuNode.ioService.historyLength()-1;i>=0;i--){
												let el = MenuNode.ioService.getHistoryItemByIndex(i);
												if(el.getParent() == this.getParent() && el.getIndexOnParent() < myIdx){
													console.log("lastest history entry : "+el.getIdentifier());
													return el;
												}
											}

										}

										// get the element that is closest to the current in terms of parent-indexes
										if(order == 'closestSibling'){

											let previousElements = new Array<MenuNode>();
											let myIdx = this.getIndexOnParent();
											for(let i=0;i<myIdx;i++){
												previousElements.push(this.parent.getChildByIndex(i));
											}
											previousElements.reverse();
											for(let el of previousElements){
												if(MenuNode.ioService.inHistory(el)){
													let popped = MenuNode.ioService.historyPop();
													while(popped != el && el != undefined){
														popped = MenuNode.ioService.historyPop();
													}	
													return el;

												}
											}
										}
										

									}else{
									let popNum = parseInt(parts[2]);
									let i = 1;
										for(i=0;i<popNum;i++){
											let trgt = MenuNode.ioService.historyPop();
											if(trgt){
												console.log("Popping "+trgt.getTitle()+"/"+trgt.getName()+"/"+trgt.getIdentifier());
											}else{
												console.log("Popping undefined");
											}
											
										}
									}
								}
								console.log("Returning...");
								let trgt = MenuNode.ioService.historyPop();
								if(!trgt){
									console.log("Returning undefined");
								}
								return trgt;

							}
							case 'parent': {

								if(parts.length>2){
									let subAddress="";
									for(let i=2;i<parts.length;i++){
										subAddress+=parts[i]
										if(i!=parts.length-1){
											subAddress+=".";
										}
									}
									subAddress="goto:"+subAddress;
									return ref.getParent().getTargetNode(subAddress);
								}

								if (ref.hasParent()) {
									return ref.getParent();
								}
								return null;
							}
							default: {
								let id = parts[1];
								console.log("Looking up " + parts[1]);
								let target = ref.findFromRoot(id);
								if (!target) {
									//console.log("Nothing found looking for "+id+". sorry.");
									id = parts.join('.');
									target = ref.findFromRoot(id);
								}else{
									console.log("Found!");
								}
								
								return target;
							}
						}
					}
				}

				default: {
					return null;
				}
			}
		}
	}
	run(fn:CallableFunction,depth:number){
		if(depth==0){
			return;
		}
		fn(this);
		for(let child of this.childs){
			child.run(fn,depth-1);
		}
	}

	findFromRoot(id: string) {
		if(MenuNode.root != null){
			return MenuNode.root.findRecursive(id);
		}
		let element: MenuNode;
		element = this;
		// ganz hoch.

		while (element.hasParent()) {
			element = element.getParent();
		}
		// suchen
		return element.findRecursive(id);
	}
	findRecursive(id): MenuNode {
		if (this.identifier == id) {
			return this;
		}
		for (let child of this.childs) {
			let element = child.findRecursive(id);
			if (element != null) {
				return element;
			}
		}
		return null;
	}

	onConfirmAction: string;
	setOnConfirmAction(oca:string){
		this.onConfirmAction=oca;
	}
	getOnConfirmTarget(){
		return this.helper.getOnConfirmTarget(this);
	}

	onConfirm(args: any) {
		return this.helper.onConfirm(args,this);
	}

	parseText(_text: string,options?:string): string {
		if(!_text){
			return "";
		}
		let text = _text;
		
		
		
		let matches= text.match(/{{[^{^}]*?}}/g)
		// von innen nach außen replacen.
		while(matches != null){
			matches.forEach((element, id) => {
				if ((element).startsWith('{{get:') || (element).startsWith('{{run:') || element.indexOf(":") == -1) {
					
					text = text.replace(element, this.evaluateGetter(element,options));
				}
				if( (element).startsWith('{{tr:')){
					text = text.replace(element,MenuNode.translator.tr(element.replace('{{tr:','').replace('}}','')));
				}
			});
			matches = text.match(/{{[^{^}]*?}}/g)
		}

		if(options=='raw'){
			return text;
		}
		if(MenuNode.translator){
			return MenuNode.translator.tr(text);
		}
		return text;
	}

	isSelected() : boolean{
		return this.evaluateBool(this.selected,false);
	}
	isEnabled():boolean{
		return ( MenuLogic.isEnabled(this) && this.evaluateBool(this.enabled,true) );
	}

	_evaluateBool(text: any, _default?: boolean):boolean{
		MenuNode._debug = true;
		let val= this._evaluateBool(text,_default);
		if(val){
			this.debug("Evaluated to true");
		}else{
			this.debug("Evaluated to false");
		}
		MenuNode._debug = false;
		return val;
	}
	evaluateBool(text: any, _default?: boolean):boolean {

		if (text === undefined || text === null) {
			return _default;
		}

		if (text === false || text === true) {
			return text;
		}

		
		
		let parts : Array<string>;
		let mode = "evaluate";
		if(text.includes("==")){
			parts = Helper.split(text,"==");
			mode = "equals";
		}
		if(text.includes("!=")){
			parts = Helper.split(text,"!=");
			mode = "equals_not";
		}
		if(mode == "evaluate"){
			parts=[text];
		}

		for(let i=0;i<parts.length;i++){
			parts[i]=this.parseText(parts[i],'raw');
			//parts[i]=this.parseText(parts[i]);
			this.debug("Parsed: "+parts[i]);
		}
		let list = [];

		if(parts.length >= 2){
			if(parts[1].startsWith('[')&&parts[1].endsWith(']')){
				if(mode == "equals"){
					mode = "contains";
				}else{
					mode = "contains_not";
				}
				list = parts[1].replace('[','').replace(']','').split(',');

			}
		}
		let translatedList = [];
		/*
		for(let el of list){
			translatedList.push(this.parseText(el));
		}*/
		//list=translatedList;
		if(parts.length == 1){
			switch(parts[0].toLowerCase()){
				case "yes":
				case "true":{
					return true;
				}
				case "no":
				case "false":{
					return false;
				}
				default:{
					return false;
				}
			}
		}
		if(parts.length == 2){
			switch(mode){
				case 'contains_not':{

					return (! (list.includes(parts[0])));
				}
				case 'contains':{
					
					let retVal = list.includes(parts[0]);
					return retVal;
				}

				case "equals":{
					this.debug("Comparing equals: "+parts[0]+ " and "+ parts[1]);
					return parts[0] == parts[1];
				}
				case "equals_not":{
					this.debug("Evaluating if "+parts[0]+" does not equal " +parts[1]);
					return parts[0] != parts[1];
				}
				default:{
					this.debug("cannot evaluate "+text);
				}
			}
		}
		return text;



	}


	getText(idx: number): string {
		let text = "";
		if (this.text && this.text.length > idx) {
			text = this.text[idx];
		}
		if (text.length > 0) {
			return this.parseText(text);
		} else {
			return "";
		}
	}
	setText(t:Array<string>){
		this.text = t;
	}

	getIdentifier() {
		return this.identifier;
	}
	toDebugMap() {
		let map = {};
		map['name'] = this.name;
		if (this.childs) {
			map['childs'] = this.childs.length + "";
		} else {
			map['childs'] = "undefined";
		}

		map['internal_id'] = "" + this.internal_id;
		if(this.infoId){
			map['infoId']=""+this.infoId;
		}
		map['timeout'] = "" + this.timeout;
		map['timeout_action'] = this.timeout_action;
		map['timeout_action_target'] = this.timeout_action_target;
		map['title'] = this.title;
		map['subtitle'] = this.subTitle;
		if (this.text) {
			map['text'] = this.text.join('\n');
		} else {
			map['text'] = "undefined";
		}
		map['back'] = this.backTarget;
		map['icon'] = this.icon;
		map['menuType'] = this.menuType;
		map['template'] = this.template;
		map['template_parameter'] = this.template_parameter;
		map['buttons'] = this.buttons;
		map['value'] = this.value;
		map['defaultValue'] = this.defaultValue;
		map['dictionary'] = this.dictionary;
		map['identifer'] = this.identifier;
		if (this.onConfirm) {
			map['onConfirm'] = this.onConfirmAction;
		}
		if (this.target) {
			map['target'] = this.target;
		}
		if(this.backTarget){
			map['backTarget']= this.backTarget;
		}
		return map;
	}
	getInfoTextId():string{
		return this.infoId;
	}

	debug(msg: string): void {
		if(!MenuNode.isDebugging()){
			return;
		}

		if (this.name) {
			console.debug("MenuNode(" + this.name + "): " + msg);
		} else {
			console.debug("MenuNode: " + msg);
		}
	}
	data:Map<string,string>;
	set(key,value){
		if(this.data == undefined){
			this.data = new Map<string,string>();
		}
		this.data.set(key,value);
	}
	get(key){

		return this.data.get(key);
	}
}